import store from '@/store/'

// eslint-disable-next-line no-unused-vars
export default function onboarding({ from, next, router, to }) {
  // console.log('middleware/onboarding | from', from)
  // console.log('middleware/onboarding | to', to)
  // console.log(store.getters['auth/is_subscription_cancelled'])

  // redirect to login if unauthenticated
  if (!store.getters['auth/is_auth']) {
    store.dispatch('CANCEL_PENDING_REQUESTS')
    if (router.currentRoute.name !== 'login') {
      return router.push({ name: 'login' })
    } else {
      return
    }

    // handle user onboarding
  } else if (!store.getters['auth/is_onboarding'] && !store.getters['auth/is_subscription_cancelled']) {
    return router.push({ name: 'dashboard' })
  }

  // OR do nothing and go next
  return next()
}
